import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import PromotionsPage from 'modules/restaurant/promotions/PromotionsPage';

export default function DashRestaurantPromotions() {
    return (
        <DashContainer title='Promoções'>
            <PromotionsPage />
        </DashContainer>
    );
}
